import React from 'react';
import { Box, useTheme } from '@mui/system';
import { Typography } from '@mui/material';

export type UnreadSeparatorProps = {
    id: string;
};

export const UnreadSeparator: React.FunctionComponent<UnreadSeparatorProps> = function (props) {
    const { id } = props;
    const { palette } = useTheme();

    return (
        <Box
            id={id}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                my: 2,
                position: 'relative',
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    height: '1px',
                    width: '100%',
                    backgroundColor: palette.primary.main,
                    zIndex: 100,
                }}
            />
            <Typography
                variant="l2dbodys"
                color="text.secondary"
                fontWeight={600}
                sx={{
                    backgroundColor: palette.background.paper,
                    px: 2,
                    zIndex: 110,
                }}
            >
                Début des nouveaux messages
            </Typography>
        </Box>
    );
};
